import "./What_Customer_Say.css";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import ReactStars from "react-rating-stars-component";
import { Customers } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading";

const What_Customer_Say = () => {
  const ratingChanged = (newRating) => {
    console.log(newRating);
  };
  const testimonialData = [
    {
      id: 1,
      name: "Milind Patil",
      image: "/assets/images/aboutus/why choose/screw.png",
      review:
        "Ayzair is one of the best solar system installation company. We installed solar system at our house through them. And while doing this work, the company's colleagues gave us very good service. The system and other information required in that context are kept very transparent. Thanks to Mr. Manoj Shivankar of Ayzair for guiding us properly for our home solar system installation.",
    },
    {
      id: 2,
      name: "Rohit Sharma",
      image: "/assets/images/aboutus/why choose/professional.png",
      review:
        "Solar panel fitting requires careful planning regarding system capacity roof structure integrity, and choosing certified installers to ensure guaranteed saving and safety. Key feedback induced insuring proper south facing tilt for maximum generation , implementing net metering , and verifying warranties. Expect significant but not always 100% energy offsets depending on weather. Thank you",
    },
    {
      id: 3,
      name: "Ananya Verma",
      image: "/assets/images/aboutus/why choose/component.png",
      review:
        "Ayzair did everything they said they would do, within the timeline they proposed. There were no surprises or “add-ons” to deal with, which I greatly appreciated. Responses to my questions/concerns was always complete, timely, and professional. Mr. Sifan was there to assist from the original proposal to the completion of the final paperwork. He also kept me updated on the status of whole program, and got me all the paperwork quickly to ensure I didn”t miss out on that opportunity. The quality product, professionalism of the whole team, and reputation of Ayzair made this a seamless and stress-free endeavor.",
    },
    {
      id: 4,
      name: "Rohit Sharma",
      image: "/assets/images/aboutus/why choose/mechanic.png",
      review:
        "Excellent service … Right form the Enquiry till completion of the plant. Share electricity bill of your home or office and they will do the rest. You just need to relax and wait till the procedure is completed.Team is very well trained and of course well behaved. Good team efforts. Ayzair Team all the very best … !!!",
    },
    {
      id: 5,
      name: "Ananya Verma",
      image: "/assets/images/aboutus/why choose/save-money.png",
      review:
        "I’m very impressed with their service.The team was professional and completed the installation on time.The system is working efficiently and my electricity bill has reduced significantly.I highly recommend Ayzair for solar solutions.",
    },
  ];

  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [customer, setCustomer] = useState([]);

  const getCustomers = async () => {
    const res = await Customers();
    if (res?.success) {
      setCustomer(res.data);
    }
  };
  useEffect(() => {
    getCustomers();
  }, []);

  const [swiperInstance, setSwiperInstance] = useState(null);
  const handleMainSliderClick = (direction) => {
    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  return (
    <section className="What_Customer_Say">
      <div className="custom_container">
        <div className="What_Customer_Say_div">
          <Common_heading
            heading={"CUSTOMER FEEDBACK"}
            subHeading={"ACROSS THE BIG PREMISES, ACROSS THE COUNTRY"}
          />

          {/* Swiper */}
          <div className="testimonial_swiper_wrapper">
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={true}
              centeredSlides={true}
              slidesPerView={3}
              spaceBetween={0}
              autoplay={{
                delay: 2500, // time between slides
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                485: { slidesPerView: 1 },
                575: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                991: { slidesPerView: 3 },
              }}
              className="testimonial_swiper"
            >
              {customer.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="testimonial_card_new">
                    <div>
                      <div className="profile_top">
                        <img
                          src={IDS?.IMG_URL + item?.logo}
                          alt={item.name}
                          className="profile_img"
                        />
                      </div>

                      <div className="quote_icon">
                        <img
                          src="/assets/images/home/what_customer_say/right-quote.png"
                          alt="quote img"
                          className="quote_img"
                        />
                      </div>
                    </div>
                    <div>
                      <h5 className="testimonial_title">Best service!</h5>

                      <p className="testimonial_review">
                        {htmlToReactParser.parse(item.description)}
                      </p>

                      <div className="bottom_section">
                        <div>
                          <h6 className="testimonial_name">{item.name}</h6>
                          <p className="testimonial_subname">{item.name}</p>
                        </div>

                        <div className="rating">
                          <ReactStars
                            count={5}
                            value={item?.rating || 0}
                            edit={false}
                            size={20}
                            activeColor="#ffd700"
                          />
                          <span>(4.5 Ratings)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default What_Customer_Say;
